<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
        <DialogBox ref="resultDialog"></DialogBox>
        <DialogBox ref="confirmationDialog"></DialogBox>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="show = false">
                <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Pedido</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                <v-btn v-if="!selectedElement.isDelivered" dark text @click="setIsDelivered(); show=false">Entregar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card>
                <v-card-subtitle v-if="selectedElement.fromVoiceAssistant">
                    <center>
                    <v-icon style="margin-right: 10px">mdi-account-voice</v-icon>
                    <span>Pedido realizado por asistente virtual</span>
                    </center>
                </v-card-subtitle>
                <v-card-title>
                <v-list-item-avatar>
                    <v-img :src="selectedElement.avatar"></v-img>
                </v-list-item-avatar>
                <span class="headline">{{ selectedElement.user }}</span>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-subtitle style="margin-top: 8px">
                <p>Fecha: {{ selectedElement.formattedDate }}</p>
                <p>Lugar: {{ selectedElement.address }}</p>
                </v-card-subtitle>
                <hr>
                <ProductsView v-bind:products="selectedElement.products"></ProductsView>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="deleteConfirmation(selectedElement)">Eliminar pedido</v-btn>
                </v-card-actions>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogBox from './DialogBox'
import ProductsView from './ProductsView'
import { DB } from '../firebase/db';

export default {
    
    props:['selectedElement', 'dialog'],

    components : {
        DialogBox,
        ProductsView
    },

    data: () => ({
        show : false
    }),

    watch : {
        dialog : function(dialog) {
            this.show = dialog;
        },
        show : function(show) {
            this.$emit('updateDialogShow', show);
        }
    },

    methods : {
        deleteItem() {
            DB.collection('orders').doc(this.selectedElement.id).delete()
            .then( () => {
                this.deleteSuccess();
                this.show = false;
            })
            .catch(() => {
                this.errorDialog("Error al eliminar el pedido.")
            })
        },

        deleteConfirmation(element) {
            this.deletedItem = element;
            this.$refs.confirmationDialog.show('warning', 
            `¿Está seguro que desea eliminar el pedido?`,
            true,
            this.deleteItem)
        },

        deleteSuccess() {
            this.$refs.resultDialog.show('info', 'Pedido eliminado con éxito.', false);
        },

        errorDialog(error) {
            this.$refs.resultDialog.show('error', error + " Compruebe la conexión a Internet. Si el problema persiste contacte con el administrador.", false);
        },

        setIsDelivered() {
            this.selectedElement.isDelivered = true;

            let item = {
                isDelivered : this.selectedElement.isDelivered
            };

            DB.collection('orders').doc(this.selectedElement.firebaseId).update(item).catch(error => {
                this.errorDialog(error)
            });
        },
    }
}
</script>